<template lang="">
    <v-card>
        <s-crud
            :config="config"
            title="Vacaciones"
            :filter="filter"
            :edit="$fun.isAdmin()"
            remove
            @save="save($event)"
            ref="ScrudVacation"
            search-input
            @rowSelected="rowSelected($event)"
            exportExcel
            height="400px"
            colorToolbar="info"
        >
            <template v-slot:options>
                <v-tooltip bottom="" v-if="$fun.isAdmin()">
                    <template v-slot:activator="{ on }">
                        <v-btn
                        v-on="on"
                        text
                        black 
                        @click="openMassApproved = true"
                        small
                        >
                            <v-icon>mdi-calendar-multiple-check</v-icon>
                        </v-btn>
                    </template>
<span>Registro Masivo de Vacaciones Gozadas</span>
</v-tooltip>
<v-tooltip bottom="" v-if="$fun.isAdmin()">
    <template v-slot:activator="{ on }">
                        <v-btn
                        v-on="on"
                        text
                        black 
                        @click="openMassApprovedDetail = true"
                        small
                        >
                            <v-icon>mdi-calendar-multiselect</v-icon>
                        </v-btn>
                    </template>
    <span>Registro Masivo de Detalle de Vacaciones Gozadas</span>
</v-tooltip>
<v-tooltip bottom="" v-if="$fun.isAdmin()">
    <template v-slot:activator="{ on }">
                        <v-btn
                        v-on="on"
                        text
                        black 
                        @click="openMass = true"
                        small
                        >
                            <v-icon>mdi-plus-circle-multiple-outline</v-icon>
                        </v-btn>
                    </template>
    <span>Registro Masivo de Vacaciones Pendientes</span>
</v-tooltip>
<div style="height: 100%; border: 1px solid white" class="mx-2"></div>
<v-tooltip bottom="" v-if="$fun.isAdmin()">
    <template v-slot:activator="{ on }">
                        <v-btn
                        v-on="on"
                        text
                        black 
                        @click="openDialogVacation()"
                        small
                        >
                            <v-icon>mdi-account-eye-outline</v-icon>
                        </v-btn>
                    </template>
    <span>Ver Vacaciones Pendientes</span>
</v-tooltip>
</template>
<template v-slot:filter v-if="filter.UnProgrammed != '0'">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="3">
                            <s-select-definition :def="1060" v-model="filter.FormType" label="Tipo Planilla" clearable :disabled="(filter.FormTypeAll?true:false )" />
                            <s-select v-if="!filter.FormTypeAll && filter.FormType" clearable  label="Año" :items="years" outlined hide-details dense v-model="year" ></s-select>
                            <s-select v-if="(filter.FormType == 1 || filter.FormType == 3 || filter.FormType == 4 || filter.FormType == 7 || filter.FormType == 8) && !filter.FormTypeAll"  clearable label="Mes" :items="itemsMonth" outlined hide-details dense v-model="filter.Month"></s-select>
                            <s-periods v-if="(filter.FormType == 2 || filter.FormType == 5 || filter.FormType == 6) && !filter.FormTypeAll" clearable  label="Periodo Semana" v-model="week" :year="year" :type="1" return-object></s-periods>
                        </v-col>
                        <v-col cols="12" md="2">
							<s-switch label="Todas las Planillas" v-model="filter.FormTypeAll" :true-value="1" :false-value="0" />
						</v-col>
                        <!-- <v-col cols="12" md="2" v-if="!filter.FormTypeAll">
                            <s-select clearable  label="Año" :items="years" outlined hide-details dense v-model="year" ></s-select>
                        </v-col>
                        <v-col cols="12" md="2" v-if="(filter.FormType == 1 || filter.FormType == 3 || filter.FormType == 4 || filter.FormType == 7 || filter.FormType == 8) && !filter.FormTypeAll">
                            <s-select  clearable label="Mes" :items="itemsMonth" outlined hide-details dense v-model="filter.Month"></s-select>
                        </v-col>
                        <v-col cols="12" md="2" v-if="(filter.FormType == 2 || filter.FormType == 5 || filter.FormType == 6) && !filter.FormTypeAll">
                            <s-periods clearable  label="Periodo Semana" v-model="week" :year="year" :type="1" return-object></s-periods>
                        </v-col> -->
                        <v-col cols="12" md="4">
                            <s-select-area v-if="$fun.isAdmin()"
								label="Area"
								v-model="filter.AreID"
                                full
                                clearable
                                noDefault
							/>
                            <s-select-area-allow v-else
                                    label="Area"
                                    v-model="filter.AreID"
                                ></s-select-area-allow>
                            <s-date label="Fecha Inicio" v-if="filter.FormTypeAll" v-model='filter.VctBeginDate' clearable />
                            <s-date label="Fecha Fin" v-if="filter.FormTypeAll" v-model='filter.VctEndDate' clearable />
                        </v-col>
                        <!-- <v-col cols="12" md="3">
                            <s-select-area-allow
                                    label="Area"
                                    v-model="filter.AreID"
                                ></s-select-area-allow>
                        </v-col> -->
                        <!-- <v-col cols="12" md="2" v-if="filter.FormTypeAll">
                                <s-date label="Fecha Inicio" v-model='filter.VctBeginDate' clearable />
                        </v-col>
                        <v-col cols="12" md="2" v-if="filter.FormTypeAll">
                            <s-date label="Fecha Fin" v-model='filter.VctEndDate' clearable />
                        </v-col> -->
                        <!-- <v-col cols="12" md="2" style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
                            <v-radio-group v-model="filter.UnProgrammed" row>
                                <v-radio label="Programados" :value="1"></v-radio>
                                <v-radio label="Pendientes" :value="0"></v-radio>
                                <v-radio label="Todos" :value="2"></v-radio>
                            </v-radio-group>
						</v-col> -->
                        <v-col cols="12" md="3" style="display: flex; flex-direction: column; align-items: start; justify-content: center;">
                            <s-select-definition
                                hidden
                                :def="1548"
                                v-model="UnProgrammedData"
                                @change="getDataUnProgrammed($event)"
                            >

                            </s-select-definition>

                            <v-label><b>Estado</b></v-label>
                            <v-autocomplete
                                v-model="UnProgrammedComputedData"
                                :items="itemsUnProgrammed"
                                hide-details
                                dense
                                multiple
                                clearable
                                chips
                                deletable-chips
                                solo
                                class="autocompleteQuery"
                                :disabled="AllUnProgrammed == 1"
                            ></v-autocomplete>
                            <div style="display: flex; justify-content: space-between; width: 100%;">
                                <s-switch label="Todos" v-model="AllUnProgrammed" :true-value="1" :false-value="0" />
                                <s-switch label="Pendientes RRHH" v-model="filter.VctStatusRRHH" :true-value="1" :false-value="2" />
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
<template v-slot="props">
                <v-container>
                    <v-row >
                        <v-col cols="12" md="4" class="s-col-form">
                            <s-text label="Dias" v-model="props.item.VctDays"/>
                        </v-col>
                        <v-col cols="12" md="8" class="s-col-form">
                            <s-text
                                label="Observación" 
                                v-model="props.item.VctObservation"/>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
<template v-slot:VctDetail="{ row }">
				<v-btn x-small :color="
                    row.ItemsDetail ? 'success' : 'error'"
                    @click="VctDetailFunc(row)">
					<v-icon>mdi-account-details-outline</v-icon>
				</v-btn>
			</template>
<template v-slot:VctApprovedName="{ row }">
                <v-chip x-small 
                    :color="
                    row.VctApproved == 1 ? 'yellow' :
                    row.VctApproved == 2 ? 'success' :
                    row.VctApproved == 3 ? 'error' :
                    row.VctApproved == 4 ? 'primary' : 'white'
                    ">
                {{ row.VctApprovedName }}
                </v-chip>
            </template>
<template v-slot:VctProgress="{ row }">
                <v-progress-linear
                        :value="progress(row)"
                        color="light-blue"
                        height="25"
                        rounded
                        striped
                        readonly
                    >
                        <template v-slot:default="{ value }">
                            <strong>{{ value | numberDefault }} %</strong>
                        </template>
</v-progress-linear>
</template>
<template v-slot:VctStatusRRHH="{ row }">
                <v-icon v-if="row.VctStatusRRHH == 0" text color="info">mdi-progress-question</v-icon>
                <v-icon v-if="row.VctStatusRRHH == 1" text color="error">mdi-chat-minus</v-icon>
                <v-icon v-if="row.VctStatusRRHH == 2" text color="success">mdi-checkbox-marked-circle-auto-outline</v-icon>
            </template>
<template v-slot:VctStatus="{ row }" v-if="$fun.isAdmin() && isAuthorizedArea">
                <div style="display: flex; gap: 5px" v-if="$fun.isAdmin() && isAuthorizedArea">
                    <v-btn :disabled="(row.VctStatus == 0 )" x-small color="success" @click="VctStatusOptionFunc(row, 0)">
                        <v-icon>mdi-cash-check</v-icon>
                    </v-btn>
                    <v-btn :disabled="(row.VctStatus == 1 )" x-small color="error" @click="VctStatusOptionFunc(row, 1)">
                        <v-icon>mdi-cash-remove</v-icon>
                    </v-btn>
                </div>
                <div v-else>
                    <v-icon v-if="row.VctStatus == 0" text color="success">mdi-cash-check</v-icon>
                    <v-icon v-if="row.VctStatus == 1" text color="error">mdi-cash-remove</v-icon>
                </div>
            </template>
            <template v-slot:VctSoldDays="{ row }">
                <v-chip x-small color="amber darken-2" dark v-if="row.VctSoldDays > 0">
                    {{ row.VctSoldDays }}d
                </v-chip>
                <span v-else class="grey--text">-</span>
            </template>
            <template v-slot:VctAccumulatedDays="{ row }">
                <v-tooltip bottom v-if="row.VctAccumulatedDays > 0">
                    <template v-slot:activator="{ on }">
                        <v-chip v-on="on" x-small color="purple" dark>
                            +{{ row.VctAccumulatedDays }}d
                        </v-chip>
                    </template>
                    <span>Acumulado de periodo {{ row.VctAccumulatedFromPeriod || 'anterior' }}</span>
                </v-tooltip>
                <span v-else class="grey--text">-</span>
            </template>
            <template v-slot:VctBalance="{ row }">
                <div v-if="row.VctIsAccumulated && row.VctTransferredDays > 0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-chip v-on="on" x-small color="grey lighten-2" class="grey--text text--darken-3 font-weight-bold">
                                0d (Traspasado)
                            </v-chip>
                        </template>
                        <span>{{ row.VctTransferredDays }} días acumulados al periodo {{ row.VctAccumulatedToPeriod }}</span>
                    </v-tooltip>
                </div>
                <span v-else :class="row.VctBalance > 0 ? 'font-weight-bold green--text text--darken-2' : 'grey--text'">
                    {{ row.VctBalance }}d
                </span>
            </template>
            <template v-slot:VctSellAction="{ row }" v-if="$fun.isAdmin() && isAuthorizedArea">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            x-small
                            color="success"
                            :disabled="!$fun.isAdmin() || row.VctBalance <= 0 || row.VctIsAccumulated"
                            @click="openSellModal(row)"
                        >
                            <v-icon x-small>mdi-cash-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Venta Parcial de Vacaciones</span>
                </v-tooltip>
            </template>
            <template v-slot:VctAccumulateAction="{ row }" v-if="$fun.isAdmin() && isAuthorizedArea">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            x-small
                            color="purple"
                            dark
                            :disabled="!$fun.isAdmin() || row.VctBalance <= 0 || row.VctIsAccumulated"
                            @click="openAccumulateModal(row)"
                        >
                            <v-icon x-small>mdi-calendar-sync</v-icon>
                        </v-btn>
                    </template>
                    <span>Acumular al Siguiente Periodo</span>
                </v-tooltip>
            </template>
</s-crud>
<v-dialog v-model="dialogAccumulate" max-width="500px" persistent>
    <v-card>
        <s-toolbar label="Acumular Vacaciones al Siguiente Periodo" dark color="purple" close @close="dialogAccumulate = false"></s-toolbar>
        <v-card-text class="pt-4">
            <v-alert type="info" dense text class="mb-4">
                <div class="subtitle-2 font-weight-bold">{{ itemAccumulate.NtpFullName }}</div>
                <div class="caption">
                    <b>Periodo Origen:</b> {{ itemAccumulate.VctPeriod }} | <b>Días Totales:</b> {{ itemAccumulate.VctDays }}<br>
                    <b>Saldo Disponible:</b> <span class="font-weight-bold green--text">{{ itemAccumulate.VctBalance }} días</span>
                </div>
            </v-alert>
            <s-text
                v-model.number="daysToAccumulate"
                label="Cantidad de Días a Acumular"
                type="number"
                :min="1"
                :max="itemAccumulate.VctBalance"
                class="mb-3"
            />
            <s-text
                v-model="observationAccumulate"
                label="Observación (Opcional)"
                placeholder="Ej: Acumulado por acuerdo o necesidad de servicio"
            />
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAccumulate = false">Cancelar</v-btn>
            <v-btn
                color="primary"
                :loading="loadingAccumulate"
                :disabled="!daysToAccumulate || daysToAccumulate <= 0 || daysToAccumulate > itemAccumulate.VctBalance"
                @click="submitAccumulation()"
            >
                Confirmar Acumulación
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
<v-dialog v-model="dialogSell" max-width="480px" persistent>
    <v-card>
        <s-toolbar label="Venta Parcial de Vacaciones" dark color="info" close @close="dialogSell = false"></s-toolbar>
        <v-card-text class="pt-4">
            <v-alert type="info" dense text class="mb-4">
                <div class="subtitle-2 font-weight-bold">{{ itemSell.NtpFullName }}</div>
                <div class="caption">
                    <b>Periodo:</b> {{ itemSell.VctPeriod }} | <b>Días Totales:</b> {{ itemSell.VctDays }}<br>
                    <b>Días Vendidos:</b> {{ itemSell.VctSoldDays || 0 }}d | 
                    <b>Saldo Disponible:</b> <span class="font-weight-bold green--text">{{ itemSell.VctBalance }} días</span>
                </div>
            </v-alert>
            <v-text-field
                v-model.number="daysToSell"
                label="Cantidad de Días a Vender"
                type="number"
                outlined
                dense
                min="1"
                :max="itemSell.VctBalance"
                hint="Ingrese la cantidad de días que el trabajador desea vender."
                persistent-hint
                :rules="[
                    v => !!v || 'Campo obligatorio',
                    v => v > 0 || 'Debe ingresar al menos 1 día',
                    v => v <= itemSell.VctBalance || 'No puede superar el saldo disponible (' + itemSell.VctBalance + ' días)'
                ]"
            ></v-text-field>
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogSell = false">Cancelar</v-btn>
            <v-btn
                color="primary"
                :loading="loadingSell"
                :disabled="!daysToSell || daysToSell <= 0 || daysToSell > itemSell.VctBalance"
                @click="submitPartialSale()"
            >
                Procesar Venta
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
<v-dialog v-model="dialogVacation" max-width="1200px">
    <v-card>
        <s-crud :config="configPrograming" title="Vacaciones Pendientes" :filter="filterPrograming"
            :edit="$fun.isAdmin()" :remove="$fun.isAdmin()" @save="savePrograming($event)" ref="ScrudVacationPrograming"
            search-input close @close="dialogVacation = false">
            <template v-slot:VcpAdd="{ row }">
                    <v-btn x-small color="primary" @click="saveVacation(row)">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>

            <template v-slot:filter v-if="$fun.isLevelArea() || $fun.isAdmin()">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="3">
                                <s-select-area 
                                    v-if="$fun.isAdmin()"
                                    label="Area"
                                    v-model="filterPrograming.AreID"
                                    full
                                    clearable
                                    noDefault
                                />
                                <s-select-area-allow
                                    v-else
                                    label="Area"
                                    v-model="filterPrograming.AreID"
                                ></s-select-area-allow>
                            </v-col>
                        </v-row>
                    </v-container>
                </template>

            <template v-slot="props">
                    <v-container>
                        <v-row >
                            <v-col cols="12" md="4" class="s-col-form">
                                <s-text label="Dias" v-model="props.item.VcpDays"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
        </s-crud>
    </v-card>
</v-dialog>

<v-dialog v-model="dialogDetail" max-width="1100px" persistent>
    <v-card>
        <v-container style="padding: 0px 0px 1px 0px">
            <s-crud :config="configVacationDetail" title="Detalle de Vacaciones" :filter="filterVacationDetail" close
                :add="$fun.isAdmin() || item?.PstBossID == filter.PstID || arePermiss.length > 0"
                :edit="($fun.isAdmin() && itemDetail?.VcdStatus != 2) || ( itemDetail?.VcdStatus != 2 && item?.PstBossID == filter.PstID) || (arePermiss.length > 0 && itemDetail?.VcdStatus != 2)"
                :remove="($fun.isAdmin() && itemDetail?.VcdStatus != 2) || ( itemDetail?.VcdStatus != 2 && item?.PstBossID == filter.PstID) || (arePermiss.length > 0 && itemDetail?.VcdStatus != 2)"
                @save="saveVacationDetail($event)" @close="funcClose()" ref="scrudVacationDetail" search-input
                @rowSelected="rowSelectedDetail($event)" :pdf="itemDetail?.VcdStatus == 2"
                @pdf="reportPdfVacationDetail($event)"
                :approve="$fun.isAdmin() && isAuthorizedArea && itemDetail?.VcdStatus == 3"
                @approved="approvedVacationDetail(itemDetail)" @disapproved="disapprovedVacationDetail(itemDetail)"
                @getFullData="getFullData($event)">
                <template v-slot="props">
                            <v-container>
                                <v-row >                                        
                                    <v-col cols="12" md="4">
                                        <s-date label="Fecha Inicio" v-model='props.item.VcdDateInit'/>
                                    </v-col>
                                    <v-col cols="12" md="4"> 
                                        <s-date label="Fecha Fin" v-model='props.item.VcdDateEnd'></s-date>
                                    </v-col>
                                    <v-col cols="12" md="2" align-self="end">
                                        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; gap: 5px;">
                                            <p style="line-height: 10px; margin: 0px; font-size: 10.625px; font-weight: bolder; color: rgba(0, 0, 0, 0.6);">Dias Totales</p>
                                            <span style="font-weight: bolder; border: 1px solid #999; border-radius: 5px; padding: 2px 10px;" :style="getStyle(props.item.VcdDateEnd)">
                                                {{calculateDays(props.item.VcdDateInit, props.item.VcdDateEnd)}}
                                            </span>
                                        </div>
                                    </v-col>
                                    <!-- <v-col cols="12" md="5">
                                        <s-text label="Observación"  v-model="props.item.VcdObservation"/>
                                    </v-col> -->
                                </v-row>
                            </v-container>
                        </template>

                <template v-slot:VcdStatusAsign="{ row }">
                            <v-btn :disabled="!(row.VcdStatus == 1 && item?.VctApproved == 2 && $fun.isAdmin() && idDetail == row.VcdID && isAuthorizedArea)" x-small color="success" @click="VcdStatusAsignFunc(row)">
                                <v-icon>mdi-account-check-outline</v-icon>
                            </v-btn>
                        </template>

                <template v-slot:VcdCheckOption="{ row }">
                            <div style="display: flex; gap: 5px" v-if="$fun.isAdmin() && isAuthorizedArea && row?.VcdStatus != 2">
                                <v-btn :disabled="row.VcdCheck == 2" x-small color="success" @click="VcdCheckOptionFunc(row, 2)">
                                    <v-icon>mdi-checkbox-marked-circle-auto-outline</v-icon>
                                </v-btn>
                                <v-btn :disabled="row.VcdCheck == 1" x-small color="error" @click="VcdCheckOptionFunc(row, 1)">
                                    <v-icon>mdi-chat-minus</v-icon>
                                </v-btn>
                            </div>
                            <div v-else>
                                <v-icon v-if="row.VcdCheck == 0" text color="info">mdi-progress-question</v-icon>
                                <v-icon v-if="row.VcdCheck == 1" text color="error">mdi-chat-minus</v-icon>
                                <v-icon v-if="row.VcdCheck == 2" text color="success">mdi-checkbox-marked-circle-auto-outline</v-icon>
                            </div>
                        </template>

                <template v-slot:VcdStatusName="{ row }">
                            <v-chip x-small 
                                :color="
                                row.VcdStatus == 1 ? 'primary' : 
                                row.VcdStatus == 3 ? 'warning' : 
                                row.VcdStatus == 4 ? 'error' : 
                                row.VcdStatus == 2 ? 'success' : 'white'"
                                >
                            {{ row.VcdStatusName }}
                            </v-chip>
                        </template>
            </s-crud>
        </v-container>
    </v-card>
</v-dialog>

<v-dialog v-model="dialogPdfVacation" v-if="dialogPdfVacation" max-width="750px" persistent>
    <PdfVacation :data="dataPdf" @close="dialogPdfVacation = false" />
</v-dialog>

<v-dialog persistent v-model="openMass" v-if="openMass" max-width="900px">
    <v-card>
        <v-container>
            <v-row>
                <v-col>
                    <s-toolbar no-border dark label="Carga Masiva de Vacaciones Pendientes" color="#8e8f91" close
                        @close="openMass = false">

                    </s-toolbar>

                    <v-card>
                        <v-col>
                            <v-row>
                                <v-col>
                                    <s-import-excel :headers="headers" @loaded="saveMassive($event)"></s-import-excel>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</v-dialog>

<v-dialog v-model="dialogError" max-width="900px">
    <v-card>
        <s-toolbar label="Errores de Carga" dark color="#CC0000" close @close="dialogError = false"></s-toolbar>
        <v-container>
            <v-row>
                <v-col>
                    <v-data-table dense
                        :headers="errorData == 2 ? headersErrorApproved : errorData == 3 ? headersErrorApprovedDetail : headersError"
                        :items="itemsError" :items-per-page="-1">
                        <template v-slot:item.VcdDateInit="{ item }">
                                    {{ $fun.formatDateView(item.VcdDateInit) }}
                                </template>
                        <template v-slot:item.VcdDateEnd="{ item }">
                                    {{ $fun.formatDateView(item.VcdDateEnd) }}
                                </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</v-dialog>
<AlertSunshine :dialog="dialogLoad" :totalItems="totalItems" :countItems="count" />

<v-dialog v-model="dialogDetailObservation" max-width="400px" persistent>
    <v-card>
        <s-toolbar label="Observación" dark color="#8e8f91" close @close="dialogDetailObservation = false" save
            @save="VcdCheckOptionFuncObservation(itemDetail,1)"></s-toolbar>
        <v-container>
            <v-row>
                <v-col>
                    <s-textarea label="Observación" v-model="observationDetail" />
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</v-dialog>

<v-dialog v-model="dialogVacationControl" max-width="400px" persistent>
    <v-card>
        <s-toolbar label="Modalidad de Pago" dark color="#8e8f91" close @close="dialogVacationControl = false" save
            @save="saveVacationControl(itemVacationControl)"></s-toolbar>
        <v-container>
            <v-row>
                <v-col>
                    <s-select-definition :def="1567" v-model="itemVacationControl.VccMethod">
                    </s-select-definition>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</v-dialog>

<v-dialog persistent v-model="openMassApproved" v-if="openMassApproved" max-width="900px">
    <v-card>
        <v-container>
            <v-row>
                <v-col>
                    <s-toolbar no-border dark label="Carga Masiva de Vacaciones Gozadas" color="#8e8f91" close
                        @close="openMassApproved = false">

                    </s-toolbar>

                    <v-card>
                        <v-col>
                            <v-row>
                                <v-col>
                                    <s-import-excel :headers="headersApproved"
                                        @loaded="saveMassiveVacationApproved($event)"></s-import-excel>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</v-dialog>

<v-dialog persistent v-model="openMassApprovedDetail" v-if="openMassApprovedDetail" max-width="900px">
    <v-card>
        <v-container>
            <v-row>
                <v-col>
                    <s-toolbar no-border dark label="Carga Masiva de Detalle de Vacaciones Gozadas" color="#8e8f91"
                        close @close="openMassApprovedDetail = false">

                    </s-toolbar>

                    <v-card>
                        <v-col>
                            <v-row>
                                <v-col>
                                    <s-import-excel :headers="headersApprovedDetail"
                                        @loaded="saveMassiveVacationApprovedDetail($event)"></s-import-excel>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</v-dialog>
</v-card>
</template>

<script>

import SText from '../../components/Utils/SText.vue'
import ServiceVacations from "../../services/HumanResource/HmnVacationsService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import SSelectPayrollAllow from '../../components/Utils/SSelectPayrollAllow.vue';
import HmnVacationsDetail from '../../services/HumanResource/HmnVacationsDetail';
import PdfVacation from './PdfVacation/PdfVacation.vue';
import Service from "@/services/General/PersonService";
import HmnVacationsProgramingService from '../../services/HumanResource/HmnVacationsProgramingService';
import { DateTime, Interval } from 'luxon';
import HmnVacationsControlService from '../../services/HumanResource/HmnVacationsControlService';
import _sGenParamService from "@/services/General/ParameterService";

export default {
    components: {
        SText,
        sToolbarPerson,
        SSelectPayrollAllow,
        PdfVacation
    },
    data() {
        return {
            openMassApproved: false,
            openMassApprovedDetail: false,
            dialogVacationControl: false,
            itemVacationControl: {},
            AllUnProgrammed: 0,
            UnProgrammedComputedData: [2],
            UnProgrammedData: null,
            itemsUnProgrammed: [],
            dialogDetailObservation: false,
            observationDetail: "",
            idDetail: 0,
            totalItems: 0,
            count: 0,
            arePermiss: [],
            dialogLoad: false,
            dialogError: false,
            openMass: false,
            dialogPdfVacation: false,
            item: {},
            itemDetail: {},
            parentVacation: {},
            filter: {
                AreID: null,
                Month: null,
                Week: null,
                FormType: null,
                FormTypeAll: 1,
                VctBeginDate: null,
                VctEndDate: null,
                Flag: 1,
                isAdmin: this.$fun.isAdmin() ? 1 : 0,
                PstID: this.$fun.getUserInfo().CtrContract?.PstID,
                NtpID: this.$fun.getUserInfo().NtpID,
                UnProgrammed: '2',
                // Programmed: 0,
                // All: 2,
                // viewMode: 0,
                AreIDUser: this.$fun.getUserInfo().CtrContract?.AreID,
                VctStatusRRHH: 2,
            },
            config: {
                service: ServiceVacations,
                model: {
                    VctID: "ID",
                    NtpID: "int",
                    NtpFullName: "string",
                    PrsDocumentNumber: "string",
                    VctDateInit: "date",
                    VctDateEnd: "date",
                    CtrAdmissionDate: "date",
                    VctIsSold: "bool",
                    VctSoldDays: "int",
                    VctAccumulatedDays: "int",
                    VctTransferredDays: "int",
                    VctIsAccumulated: "bool",
                },
                headers: [
                    { text: "ID", value: "VctID" },
                    { text: "Nombre y Apellidos", value: "NtpFullName" },
                    { text: "DNI", value: "PrsDocumentNumber" },
                    { text: "Tipo de Planilla", value: "TypePayrollName" },
                    { text: "Area", value: "AreName" },
                    { text: "Cargo", value: "PstName" },
                    { text: "Fecha de Ingreso", value: "CtrAdmissionDate", width: 100 },
                    { text: "Dias de Vacaciones", value: "VctDays", width: 90, align: "center" },
                    { text: "Periodo", value: "VctPeriod", width: 90, align: "center" },
                    { text: "Días Acum.", value: "VctAccumulatedDays", width: 85, align: "center" },
                    { text: "Días Vendidos", value: "VctSoldDays", width: 90, align: "center" },
                    { text: "Saldo de Vacaciones", value: "VctBalance", width: 70, align: "center" },
                    { text: "Detalle", value: "VctDetail", width: 60, align: "center" },
                    { text: "Vender", value: "VctSellAction", width: 70, align: "center" },
                    { text: "Acumular", value: "VctAccumulateAction", width: 75, align: "center" },
                    { text: "Estado", value: "VctApprovedName", width: 130, align: "center" },
                    { text: "Progreso", value: "VctProgress", width: 130, align: "center" },
                    { text: "Visto bueno por RRHH", value: "VctStatusRRHH", width: 80, align: "center" },
                    //   { text: "Pagado", value: "VctStatus", width: 80, align: "center" },
                ],
            },
            filterPrograming: {
                AreID: null,
                isAdmin: this.$fun.isAdmin() ? 1 : 0,
                PstID: this.$fun.getUserInfo().CtrContract?.PstID,
                NtpID: this.$fun.getUserInfo().NtpID
            },
            configPrograming: {
                service: HmnVacationsProgramingService,
                model: {
                    VcpID: "ID",
                    VcpAdd: "",
                    CtrAdmissionDate: "date",
                },
                headers: [
                    { text: "DNI", value: "PrsDocumentNumber" },
                    { text: "Nombre y Apellidos", value: "NtpFullName" },
                    { text: "Area", value: "AreName" },
                    { text: "Cargo", value: "PstName" },
                    { text: "Fecha de Ingreso", value: "CtrAdmissionDate" },
                    { text: "Periodo", value: "VcpPeriod" },
                    { text: "Dias de Vacaciones", value: "VcpDays", width: 90 },
                    { text: "Programar", value: "VcpAdd", width: 50, align: "center" },
                ]
            },
            isAdmin: this.$fun.isAdmin(),
            week: null,
            year: null,
            itemPerson: {},
            dialogVacation: false,
            itemsVacation: [],
            dialogDetail: false,
            configVacationDetail: {
                service: HmnVacationsDetail,
                model: {
                    VcdID: "ID",
                    NtpID: "int",
                    NtpFullName: "string",
                    PrsDocumentNumber: "string",
                    VcdDateInit: "date",
                    VcdDateEnd: "date",
                },
                headers: [
                    { text: "ID", value: "VcdID" },
                    { text: "Registrar salida de vacaciones", value: "VcdStatusAsign", width: 70 },
                    { text: "DNI", value: "PrsDocumentNumber" },
                    { text: "Nombre y Apellidos", value: "NtpFullName" },
                    { text: "Dias de Vacaciones", value: "VcdDays", width: 90 },
                    { text: "Fecha Inicio", value: "VcdDateInit", width: 100 },
                    { text: "Fecha Fin", value: "VcdDateEnd", width: 100 },
                    { text: "Periodo", value: "VctPeriod", width: 100 },
                    { text: "Estatus", value: "VcdStatusName", width: 120 },
                    { text: "Visto bueno por RRHH", value: "VcdCheckOption", width: 100, align: "center" },
                    { text: "Observaciones", value: "VcdObservation", width: 100 },
                ],
            },
            filterVacationDetail: {
                VctID: null
            },
            dataPdf: {},
            headers: [
                {
                    column: "DNI",
                    value: "DNI",
                    text: "DNI"
                },
                {
                    column: "NOMBRE",
                    value: "NOMBRE",
                    text: "NOMBRE"
                },
                {
                    column: "DIAS_DE_VACACIONES_PENDIENTES",
                    value: "DIAS_DE_VACACIONES_PENDIENTES",
                    text: "DIAS DE VACACIONES PENDIENTES",
                    width: 100
                },
                {
                    column: "PERIODO",
                    value: "PERIODO",
                    text: "PERIODO"
                },
            ],
            headersApproved: [
                {
                    column: "DNI",
                    value: "DNI",
                    text: "DNI"
                },
                {
                    column: "NOMBRE",
                    value: "NOMBRE",
                    text: "NOMBRE"
                },
                {
                    column: "DIAS_DE_VACACIONES",
                    value: "DIAS_DE_VACACIONES",
                    text: "DIAS DE VACACIONES",
                    width: 100
                },
                {
                    column: "PERIODO",
                    value: "PERIODO",
                    text: "PERIODO"
                },
            ],
            headersApprovedDetail: [
                {
                    column: "DNI",
                    value: "DNI",
                    text: "DNI"
                },
                {
                    column: "NOMBRE",
                    value: "NOMBRE",
                    text: "NOMBRE"
                },
                {
                    column: "DIAS_DE_VACACIONES",
                    value: "DIAS_DE_VACACIONES",
                    text: "DIAS DE VACACIONES",
                    width: 100
                },
                {
                    column: "PERIODO",
                    value: "PERIODO",
                    text: "PERIODO"
                },
                {
                    column: "FECHA_INICIO",
                    value: "FECHA_INICIO",
                    text: "FECHA_INICIO",
                    date: true
                },
                {
                    column: "FECHA_FIN",
                    value: "FECHA_FIN",
                    text: "FECHA_FIN",
                    date: true
                },
                {
                    column: "OBSERVACION",
                    value: "OBSERVACION",
                    text: "OBSERVACION"
                }
            ],
            headersError: [
                { text: "DNI", value: "PrsDocumentNumber" },
                { text: "Nombre y Apellidos", value: "NtpFullName" },
                { text: "Dias de Vacaciones", value: "VcpDays" },
                { text: "Periodo", value: "VctPeriod", width: 100 },
                { text: "Observacion", value: "Message" },
            ],
            headersErrorApproved: [
                { text: "DNI", value: "PrsDocumentNumber" },
                { text: "Nombre y Apellidos", value: "NtpFullName" },
                { text: "Dias de Vacaciones", value: "VctDays" },
                { text: "Periodo", value: "VctPeriod", width: 100 },
                { text: "Observacion", value: "Message" },
            ],
            headersErrorApprovedDetail: [
                { text: "DNI", value: "PrsDocumentNumber" },
                { text: "Nombre y Apellidos", value: "NtpFullName" },
                { text: "Dias de Vacaciones", value: "VcdDays" },
                { text: "Fecha de Inicio", value: "VcdDateInit" },
                { text: "Fecha de Fin", value: "VcdDateEnd" },
                { text: "Periodo", value: "VctPeriod", width: 100 },
                { text: "Observacion", value: "Message" },
            ],
            authorizedAreaIds: [1018, 1034],
            errorData: 1,
            itemsError: [],
            dialogSell: false,
            itemSell: {},
            daysToSell: null,
            loadingSell: false,
            dialogAccumulate: false,
            itemAccumulate: {},
            daysToAccumulate: null,
            observationAccumulate: "",
            loadingAccumulate: false,
        }
    },
    computed: {
        isAuthorizedArea() {
            return this.$fun.isAdmin() || this.authorizedAreaIds.includes(this.filter.AreIDUser);
        },
    },
    methods: {
        loadAuthorizedAreaIds() {
            _sGenParamService.search({ PrmName: "AuthorizedAreaIds" }, this.$fun.getUserID())
                .then((resp) => {
                    if (resp.data != null && resp.data.PrmValue) {
                        this.authorizedAreaIds = resp.data.PrmValue
                            .split(',')
                            .map(v => parseInt(v.trim()))
                            .filter(v => !isNaN(v));
                    }
                })
                .catch(() => {
                    // Keep default [1018, 1034] if parameter not found
                });
        },
        progress(row) {
            const countDetail = Number(row.CountDetail);
            const totalItems = Number(row.VctDays);

            if (row.VctDays == 0 && row.VctApproved == 5) return 100;
            if (totalItems === 0) return 0;
            return (countDetail / totalItems) * 100;
        },
        save(item) {
            item.VctDays = this.$fun.trimFull(String(item.VctDays), true);
            if (item.VctDays == "") {
                this.$fun.alert("La cantidad de dias es obligatoria", "warning");
                return;
            }
            item.save();
        },
        savePrograming(item) {
            item.VcpDays = this.$fun.trimFull(String(item.VcpDays), true);
            if (item.VcpDays == "") {
                this.$fun.alert("La cantidad de dias es obligatoria", "warning");
                return;
            }
            item.save();
        },
        async saveMassive(items) {
            this.totalItems = items.length;
            this.count = 0;
            this.itemsError = [];

            this.$fun.alertFull("¿Seguro de guardar vacaciones?", "question").then(async (resp) => {
                if (resp.value) {
                    this.dialogLoad = true;

                    for (const item of items) {

                        if (item.DNI) {
                            const persona = {
                                VcpDays: item.DIAS_DE_VACACIONES_PENDIENTES,
                                VcpPeriod: this.$fun.trimFull(item.PERIODO, true),
                                UsrCreateID: this.$fun.getUserID(),
                                NtpFullName: item.NOMBRE,
                                PrsDocumentNumber: this.$fun.trimFull(item.DNI, true),
                            };

                            try {
                                await HmnVacationsProgramingService.save(persona, this.$fun.getUserID()).then((res) => {
                                    if (res.status == 200) {
                                        this.count++;
                                    }
                                })
                            } catch (error) {
                                persona.Message = error.response.data.Message;
                                this.itemsError.push(persona);
                                console.error("Error al registrar persona", persona, error);
                            }
                        }
                    }

                    this.openMass = false;
                    this.dialogLoad = false;
                    if (this.count == this.totalItems) {
                        this.$fun.alert("Guardado Correctamente", "success");
                    } else {
                        this.$fun.alert("Guardado con Errores", "warning");
                        this.errorData = 1;
                        this.dialogError = true;
                    }
                }
            })
        },
        async saveMassiveVacationApproved(items) {
            this.totalItems = items.length;
            this.count = 0;
            this.itemsError = [];

            this.$fun.alertFull("¿Seguro de guardar vacaciones?", "question").then(async (resp) => {
                if (resp.value) {
                    this.dialogLoad = true;

                    for (const item of items) {

                        if (item.DNI) {
                            const persona = {
                                VctDays: item.DIAS_DE_VACACIONES,
                                VctPeriod: this.$fun.trimFull(item.PERIODO, true),
                                UsrCreateID: this.$fun.getUserID(),
                                NtpFullName: item.NOMBRE,
                                PrsDocumentNumber: this.$fun.trimFull(item.DNI, true),
                            };

                            try {
                                console.log(persona);
                                await HmnVacationsProgramingService.saveApproved(persona, this.$fun.getUserID()).then((res) => {
                                    if (res.status == 200) {
                                        this.count++;
                                    }
                                })
                            } catch (error) {
                                persona.Message = error.response.data.Message;
                                this.itemsError.push(persona);
                                console.error("Error al registrar persona", persona, error);
                            }
                        }
                    }

                    this.openMassApproved = false;
                    this.dialogLoad = false;
                    if (this.count == this.totalItems) {
                        this.$fun.alert("Guardado Correctamente", "success");
                    } else {
                        this.$fun.alert("Guardado con Errores", "warning");
                        this.errorData = 2;
                        this.dialogError = true;
                    }
                }
            })
        },
        async saveMassiveVacationApprovedDetail(items) {
            this.totalItems = items.length;
            this.count = 0;
            this.itemsError = [];

            this.$fun.alertFull("¿Seguro de guardar detalle de vacaciones?", "question").then(async (resp) => {
                if (resp.value) {
                    this.dialogLoad = true;

                    for (const item of items) {

                        if (item.DNI) {
                            const persona = {

                                VcdDays: item.DIAS_DE_VACACIONES,
                                VctPeriod: this.$fun.trimFull(item.PERIODO, true),
                                UsrCreateID: this.$fun.getUserID(),
                                NtpFullName: item.NOMBRE,
                                PrsDocumentNumber: this.$fun.trimFull(item.DNI, true),
                                VcdDateInit: item.FECHA_INICIO,
                                VcdDateEnd: item.FECHA_FIN,
                                VcdObservation: item.OBSERVACION
                            };

                            try {
                                console.log(persona);
                                await HmnVacationsProgramingService.saveApprovedDetail(persona, this.$fun.getUserID()).then((res) => {
                                    if (res.status == 200) {
                                        this.count++;
                                    }
                                })
                            } catch (error) {
                                persona.Message = error.response.data.Message;
                                this.itemsError.push(persona);
                                console.error("Error al registrar persona", persona, error);
                            }
                        }
                    }

                    this.openMassApprovedDetail = false;
                    this.dialogLoad = false;
                    if (this.count == this.totalItems) {
                        this.$fun.alert("Guardado Correctamente", "success");
                    } else {
                        this.$fun.alert("Guardado con Errores", "warning");
                        this.errorData = 3;
                        this.dialogError = true;
                    }
                }
            })
        },
        selection() {
            if (this.filter.Month != null) {
                let month = this.filter.Month.toString().padStart(2, "0");
                let year = this.year;

                this.filter.VctBeginDate = this.$moment(`${year}-${month}-01`).format("YYYY-MM-DD");

                this.filter.VctEndDate = this.$moment(`${year}-${month}-01`).endOf("month").format("YYYY-MM-DD");
            }
        },
        openDialogVacation() {
            this.dialogVacation = true;
            this.$refs.ScrudVacationPrograming.refresh();

            console.log("this.filter", this.filter);
            // this.dialogLoad = true;

            // this.textSearch = '';

            // ServiceVacations.list(this.textSearch, this.filter.isAdmin, this.filter.NtpID, this.filter.PstID, this.$fun.getUserID()).then((res) => {
            //     if (res.status == 200){
            //         // console.log('res', res.data);
            //         this.itemsVacation = res.data;
            //         this.dialogLoad = false;
            //     }
            // })
        },
        saveVacation(item) {
            const obj = {
                NtpID: item.NtpID,
                VctPeriod: item.VcpPeriod,
                VctDays: item.VcpDays,
                PstBossID: item.PstBossID,
                VctApproved: 1,
                VctStatus: 1,
                UsrCreateID: this.$fun.getUserID(),
            }

            this.$fun.alertFull("¿Seguro de programar vacaciones?", "question")
                .then(r => {
                    if (r.value) {
                        ServiceVacations.save(obj, this.$fun.getUserID()).then((res) => {
                            if (res.status == 200) {
                                this.$fun.alert("Vacaciones Guardadas", "success");
                                this.dialogVacation = false;
                                this.$refs.ScrudVacation.refresh();

                                // this.filterVacationDetail.VctID = res.data.VctID;
                                // this.dialogDetail = true;
                            }
                        })
                    }
                });
        },
        async VcdStatusAsignFunc(item) {
            this.itemVacationControl = { ...item };
            this.dialogVacationControl = true;
        },
        async saveVacationControl(item) {

            this.$fun.alertFull("¿Salio de Vacaciones?", "question")
                .then(async r => {
                    if (r.value) {
                        this.dialogVacationControl = false;

                        const itemData = { ...item };
                        itemData.VcdStatus = 2;
                        itemData.UsrCreateID = this.$fun.getUserID();


                        // itemData.VccMethod = 1;  // 1 = Pago Anticipado, 2 = Fecha habitual de pago
                        itemData.VccStatus = 1;

                        let VccMethod = itemData.VccMethod;

                        const result = this.splitVacationPeriod(itemData, VccMethod);
                        console.log("result", result);

                        for (let i = 0; i < result.length; i++) {
                            const item = result[i];
                            console.log("item", item);
                            await HmnVacationsControlService.save(item, this.$fun.getUserID()).then((res) => {
                                if (res.status == 200) {
                                    // this.$fun.alert("Estado Actualizado","success");
                                }
                            })
                        }

                        HmnVacationsDetail.save(itemData, this.$fun.getUserID()).then((res) => {
                            if (res.status == 200) {
                                this.$fun.alert("Estado Actualizado", "success");
                                this.$refs.scrudVacationDetail.refresh();
                            }
                        })
                    }
                })
        },
        splitVacationPeriod(item, VccMethod) {
            const result = [];
            const payrollMonthly = [1, 4, 7, 8];
            const payrollWeekly = [2, 5, 11];

            let start = DateTime.fromISO(item.VcdDateInit).startOf('day');
            const end = DateTime.fromISO(item.VcdDateEnd).startOf('day');

            // Calcular fecha de pago anticipado una sola vez si aplica
            let anticipadoDatePay = null;
            if (VccMethod == 1) {
                let next = DateTime.now().startOf('day').plus({ days: 1 });
                while (next.weekday !== 4) {
                    next = next.plus({ days: 1 });
                }
                anticipadoDatePay = next.toISODate();
            }

            // Pago mensual → último jueves del mes
            const getMonthlyPayDate = (d) => {
                let thursday = d.endOf('month').startOf('day');
                while (thursday.weekday !== 4) {
                    thursday = thursday.minus({ days: 1 });
                }
                return thursday.toISODate();
            };

            // Pago semanal → primer jueves después del fin
            const getWeeklyPayDate = (d) => {
                let next = d.plus({ days: 1 }).startOf('day');
                while (next.weekday !== 4) {
                    next = next.plus({ days: 1 });
                }
                return next.toISODate();
            };

            if (payrollMonthly.includes(item.TypePayroll)) {
                // Planilla mensual
                while (start <= end) {
                    const monthEnd = start.endOf('month').startOf('day');
                    const currentEnd = monthEnd < end ? monthEnd : end;

                    const sub = {
                        ...item,
                        VccDateInit: start.toISODate(),
                        VccDateEnd: currentEnd.toISODate(),
                        VccDays: Math.floor(currentEnd.diff(start, 'days').days) + 1,
                        VccSemOMonth: start.month,
                        VccDatePay: VccMethod === 1 ? anticipadoDatePay : getMonthlyPayDate(start),
                    };

                    result.push(sub);
                    start = currentEnd.plus({ days: 1 }).startOf('day');
                }

            } else if (payrollWeekly.includes(item.TypePayroll)) {
                // Planilla semanal
                while (start <= end) {
                    const daysUntilSunday = 7 - start.weekday;
                    const weekEnd = start.plus({ days: daysUntilSunday }).startOf('day');
                    const currentEnd = weekEnd < end ? weekEnd : end;

                    const sub = {
                        ...item,
                        VccDateInit: start.toISODate(),
                        VccDateEnd: currentEnd.toISODate(),
                        VccDays: Math.floor(currentEnd.diff(start, 'days').days) + 1,
                        VccSemOMonth: start.weekNumber,
                        VccDatePay: VccMethod === 1 ? anticipadoDatePay : getWeeklyPayDate(currentEnd),
                    };

                    result.push(sub);
                    start = currentEnd.plus({ days: 1 }).startOf('day');
                }
            }

            return result;
        },
        VcdCheckOptionFunc(item, check) {
            if (check == 1) {
                this.dialogDetailObservation = true;
                this.observationDetail = item.VcdObservation || "";
            } else {
                const itemData = { ...item };
                itemData.VcdObservation = "";
                itemData.VcdCheck = check;
                itemData.UsrCreateID = this.$fun.getUserID();

                HmnVacationsDetail.save(itemData, this.$fun.getUserID()).then((res) => {
                    if (res.status == 200) {
                        this.$fun.alert("Estado Actualizado", "success");
                        this.$refs.scrudVacationDetail.refresh();
                    }
                })
            }
        },
        VcdCheckOptionFuncObservation(item, check) {
            this.dialogDetailObservation = false;
            const itemData = { ...item };
            itemData.VcdObservation = this.observationDetail;
            itemData.VcdCheck = check;
            itemData.UsrCreateID = this.$fun.getUserID();

            HmnVacationsDetail.save(itemData, this.$fun.getUserID()).then((res) => {
                if (res.status == 200) {
                    this.$fun.alert("Estado Actualizado", "success");
                    this.$refs.scrudVacationDetail.refresh();
                }
            })
        },

        VctStatusOptionFunc(item, check) {
            const itemData = { ...item };
            itemData.VctStatus = check;
            itemData.UsrCreateID = this.$fun.getUserID();

            console.log("itemData", itemData);

            ServiceVacations.save(itemData, this.$fun.getUserID()).then((res) => {
                if (res.status == 200) {
                    this.$fun.alert("Estado Actualizado", "success");
                    this.$refs.ScrudVacation.refresh();
                }
            })
        },
        openSellModal(row) {
            this.itemSell = { ...row };
            this.daysToSell = null;
            this.dialogSell = true;
        },
        submitPartialSale() {
            if (!this.daysToSell || this.daysToSell <= 0) {
                this.$fun.alert("Ingrese una cantidad válida de días a vender.", "warning");
                return;
            }
            if (this.daysToSell > this.itemSell.VctBalance) {
                this.$fun.alert("La cantidad no puede superar el saldo disponible (" + this.itemSell.VctBalance + " días).", "warning");
                return;
            }

            this.$fun.alertFull(
                `¿Está seguro de vender ${this.daysToSell} día(s) de vacaciones para ${this.itemSell.NtpFullName}?`,
                "question"
            ).then((r) => {
                if (r.value) {
                    this.loadingSell = true;
                    ServiceVacations.sell(this.itemSell.VctID, this.daysToSell, this.$fun.getUserID())
                        .then((res) => {
                            this.loadingSell = false;
                            if (res.status == 200) {
                                this.$fun.alert("Venta parcial de vacaciones registrada exitosamente.", "success");
                                this.dialogSell = false;
                                this.$refs.ScrudVacation.refresh();
                            }
                        })
                        .catch((err) => {
                            this.loadingSell = false;
                            this.$fun.alert(
                                "Error al registrar la venta: " + (err.response?.data?.Message || err.message),
                                "error"
                            );
                        });
                }
            });
        },
        openAccumulateModal(row) {
            this.itemAccumulate = { ...row };
            this.daysToAccumulate = row.VctBalance;
            this.observationAccumulate = "";
            this.dialogAccumulate = true;
        },
        submitAccumulation() {
            if (!this.daysToAccumulate || this.daysToAccumulate <= 0) {
                this.$fun.alert("Ingrese una cantidad válida de días a acumular.", "warning");
                return;
            }
            if (this.daysToAccumulate > this.itemAccumulate.VctBalance) {
                this.$fun.alert("La cantidad no puede superar el saldo disponible (" + this.itemAccumulate.VctBalance + " días).", "warning");
                return;
            }

            this.$fun.alert(
                `¿Está seguro de acumular ${this.daysToAccumulate} día(s) del periodo ${this.itemAccumulate.VctPeriod} hacia el siguiente periodo para ${this.itemAccumulate.NtpFullName}?`,
                "question"
            ).then((r) => {
                if (r && r.value) {
                    this.loadingAccumulate = true;
                    const payload = {
                        SourceVctID: this.itemAccumulate.VctID,
                        DaysToAccumulate: this.daysToAccumulate,
                        Observation: this.observationAccumulate,
                    };
                    ServiceVacations.accumulate(payload, this.$fun.getUserID())
                        .then((res) => {
                            this.loadingAccumulate = false;
                            if (res.status == 200) {
                                this.$fun.alert("Vacaciones acumuladas exitosamente al siguiente periodo.", "success");
                                this.dialogAccumulate = false;
                                this.$refs.ScrudVacation.refresh();
                            }
                        })
                        .catch((err) => {
                            this.loadingAccumulate = false;
                            this.$fun.alert(
                                "Error al acumular vacaciones: " + (err.response?.data?.Message || err.message),
                                "error"
                            );
                        });
                }
            });
        },
        VctDetailFunc(row) {
            this.filterVacationDetail.VctID = row.VctID;
            this.parentVacation = { ...row };
            this.dialogDetail = true;
        },
        validateVacationDates(CtrAdmissionDate, VctPeriod, VcdDateInit, VcdDateEnd) {

            const [_, endYearStr] = VctPeriod.split('-');
            const endYear = parseInt(endYearStr, 10);

            // 🔒 Parse seguro (Luxon maneja todo bien)
            const admissionDate = DateTime.fromISO(CtrAdmissionDate);
            const vacationStart = DateTime.fromISO(VcdDateInit);
            const vacationEnd = DateTime.fromISO(VcdDateEnd);

            // ❌ Validaciones
            if (!admissionDate.isValid || !vacationStart.isValid || !vacationEnd.isValid) return false;
            if (vacationStart > vacationEnd) return false;

            // 📅 Aniversario
            const periodStart = DateTime.fromObject({
                year: endYear,
                month: admissionDate.month,
                day: admissionDate.day
            });

            const periodEnd = periodStart.plus({ years: 1 });

            // 📦 Intervalo de vacaciones
            const vacationInterval = Interval.fromDateTimes(vacationStart, vacationEnd);
            const validInterval = Interval.fromDateTimes(periodStart, periodEnd);

            // ✅ Validación elegante
            return validInterval.contains(vacationStart) && validInterval.contains(vacationEnd);
        },
        async saveVacationDetail(item) {
            let validated = this.validateVacationDates(this.parentVacation.CtrAdmissionDate, this.parentVacation.VctPeriod, item.VcdDateInit, item.VcdDateEnd);

            if (!item.VcdID) {
                item.VcdStatus = 1;
            }
            item.VctID = this.filterVacationDetail.VctID;

            if (!validated) {
                item.VcdStatus = 3;
            }

            item.PstBoss = this.parentVacation.PstBossID ? this.parentVacation.PstBossID == this.filter.PstID ? 1 : 0 : 0;

            await item.save();

            if (!validated) {
                setTimeout(() => {
                    this.$fun.alertFull("Las fechas no estan dentro del periodo de vacaciones, se enviara para aprobacion de RRHH", "warning");
                }, 1000);
            }

            this.$refs.ScrudVacation.refresh();
        },
        rowSelected(item) {
            if (item !== null) {
                this.item = item[0];
            } else {
                this.item = {};
            }
        },
        rowSelectedDetail(item) {
            if (item !== null) {
                this.itemDetail = item[0];
                // console.log('itemDetail', this.itemDetail);
            } else {
                this.itemDetail = {};
            }
        },
        funcClose() {
            this.dialogDetail = false;
            this.$refs.ScrudVacation.refresh();
        },
        reportPdfVacationDetail(item) {
            if (item != null) {
                console.log('item', item);
                this.dataPdf = item;
                this.dialogPdfVacation = true;
            }
        },
        calculateDays(begin, end) {
            if (begin != null && end != null) {
                let diffTime = new Date(end) - new Date(begin);
                let days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                return days >= 0 ? days + 1 : days;
            }
            return null;
        },
        getStyle(dateEnd) {
            const today = new Date();
            const endDate = new Date(dateEnd + 'T23:59:59');

            if (endDate < today) {
                return {
                    backgroundColor: '#ff0000',
                    color: '#ffffff',
                };
            }

            return {
                backgroundColor: '#ffffff',
                color: '#000000',
            };
        },
        approvedVacationDetail(item) {
            const itemData = { ...item };

            itemData.VcdStatus = 1;
            itemData.UsrCreateID = this.$fun.getUserID();

            this.$fun.alertFull("¿Seguro de aprobar las vacaciones?", "question")
                .then(r => {
                    if (r.value) {
                        HmnVacationsDetail.save(itemData, this.$fun.getUserID()).then((res) => {
                            if (res.status == 200) {
                                this.$fun.alert("Vacaciones Aprobadas", "success");
                                this.$refs.scrudVacationDetail.refresh();
                            }
                        })
                    }
                })
        },
        disapprovedVacationDetail(item) {
            const itemData = { ...item };

            itemData.VcdStatus = 4;
            itemData.UsrCreateID = this.$fun.getUserID();

            this.$fun.alertFull("¿Seguro de desaprobar las vacaciones?", "question")
                .then(r => {
                    if (r.value) {
                        HmnVacationsDetail.save(itemData, this.$fun.getUserID()).then((res) => {
                            if (res.status == 200) {
                                this.$fun.alert("Vacaciones Desaprobadas", "success");
                                this.$refs.scrudVacationDetail.refresh();
                            }
                        })
                    }
                })
        },
        getFullData(data) {
            if (!data?.data?.length) {
                this.idDetail = 0;
                return;
            }

            const today = DateTime.now().startOf("day");

            const active = data.data.filter(item => item.VcdStatus === 1);

            const pastOrToday = active.filter(item =>
                DateTime.fromSQL(item.VcdDateInit).startOf("day") <= today
            );

            if (pastOrToday.length > 0) {
                const selected = pastOrToday.reduce((prev, curr) => {
                    const prevDate = DateTime.fromSQL(prev.VcdDateInit).startOf("day");
                    const currDate = DateTime.fromSQL(curr.VcdDateInit).startOf("day");
                    return currDate < prevDate ? curr : prev;
                });
                this.idDetail = selected.VcdID;
                return;
            }

            const future = active.filter(item =>
                DateTime.fromSQL(item.VcdDateInit).startOf("day") > today
            );

            if (future.length > 0) {
                const closest = future.reduce((prev, curr) => {
                    const prevDiff = DateTime.fromSQL(prev.VcdDateInit).diff(today, "days").days;
                    const currDiff = DateTime.fromSQL(curr.VcdDateInit).diff(today, "days").days;
                    return currDiff < prevDiff ? curr : prev;
                });
                this.idDetail = closest.VcdID;
                return;
            }

            this.idDetail = 0;
        },
        getDataUnProgrammed(data) {
            this.itemsUnProgrammed = data.map(item => ({
                value: item.DedValue,
                text: item.DedDescription
            }));
        }
    },
    created() {
        this.itemsMonth = this.$const.Months;
        this.years = this.$fun.getTop5LastYears();
        this.loadAuthorizedAreaIds();

        if (this.$fun.isLevelArea()) {
            this.arePermiss = this.$fun.getSecurity().AreasAllow;
            this.filterPrograming.AreID = this.arePermiss[0].AreID;
            this.filter.AreID = this.arePermiss[0].AreID;
        }

        if (this.arePermiss.length == 0 && !this.$fun.isAdmin()) {
            this.filter.UnProgrammed = '0';
        }
    },
    watch: {
        'filter.Month'() {
            this.selection();
        },
        year() {
            this.week = [];
        },
        week() {
            this.filter.VctBeginDate = this.week.PdsDateBegin;
            this.filter.VctEndDate = this.week.PdsDateEnd;
        },
        'filter.FormTypeAll'() {
            this.filter.FormType = null;
            this.filter.VctBeginDate = null;
            this.filter.VctEndDate = null;
            this.week = [];
        },
        UnProgrammedComputedData() {
            this.filter.UnProgrammed = this.UnProgrammedComputedData.join(', ');
        },
        AllUnProgrammed() {
            if (this.AllUnProgrammed == 1) {
                this.filter.UnProgrammed = '10';
            } else {
                this.filter.UnProgrammed = this.UnProgrammedComputedData.join(', ');
            }
        }
    },
}
</script>